export default __webpack_public_path__ + "static/media/psincome.ad14a903.webp";